export { default as ComposerAspectRatioFrame } from './ComposerAspectRatioFrame';
